import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FarmApiService } from 'src/app/core/api/farm-api.service';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { ModalService } from 'src/app/core/services/modal.service';

@Component({
  selector: 'app-location-info',
  templateUrl: './location-info.component.html',
  styleUrls: ['./location-info.component.scss'],
})
export class LocationInfoComponent extends BaseModal implements OnInit {
  @Input() previousData
  selected: string = ""
  constructor(private modalService: ModalService, private farmService: FarmApiService, private translate: TranslateService) {
    super();
    super._modalService = modalService;
  }

  ngOnInit() {
    super.ngOnInit();
  }
  placesList: Array<any>

  onSearchChange(ev) {
    let query = ev.detail.value
    if (this.selected) {
      this.dismiss(null);
    }
    this.selected = ""
    this.farmService.Geocoding(query, this.translate.currentLang).subscribe((res: any) => {
      this.placesList = res?.features.filter(t => {
        return Array.isArray(t.place_type) && t.place_type.some(t => t === 'place')
      })
    })
  }

  select(item) {
    this.selected = item.place_name
    this.dismiss(this.selected, "city-data");
  }

}
